var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhDot1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 173,
    viewBox: "0 0 178 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5557,
    cy: 111.508,
    r: 11.2979,
    fill: "#AE9142"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5557,
    cy: 161.219,
    r: 11.2979,
    fill: "#AE9142"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.2666,
    cy: 111.508,
    r: 11.2979,
    fill: "#0C2340"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.2666,
    cy: 161.219,
    r: 11.2979,
    fill: "#AE9142"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.556,
    cy: 161.219,
    r: 11.2979,
    transform: "rotate(-90 116.556 161.219)",
    fill: "#AE9142"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.267,
    cy: 161.219,
    r: 11.2979,
    transform: "rotate(-90 166.267 161.219)",
    fill: "#AE9142"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.556,
    cy: 111.509,
    r: 11.2979,
    transform: "rotate(-90 116.556 111.509)",
    fill: "#0C2340"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.267,
    cy: 111.509,
    r: 11.2979,
    transform: "rotate(-90 166.267 111.509)",
    fill: "#AE9142"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.556,
    cy: 61.7981,
    r: 11.2979,
    transform: "rotate(-90 116.556 61.7981)",
    fill: "#AE9142"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.267,
    cy: 61.7981,
    r: 11.2979,
    transform: "rotate(-90 166.267 61.7981)",
    fill: "#0C2340"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.556,
    cy: 12.0871,
    r: 11.2979,
    transform: "rotate(-90 116.556 12.0871)",
    fill: "#AE9142"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.267,
    cy: 12.0871,
    r: 11.2979,
    transform: "rotate(-90 166.267 12.0871)",
    fill: "#AE9142"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhDot1);
export default __webpack_public_path__ + "static/media/ph__dot1.f7d1dd97b40eb7924bac0d6e78b80b22.svg";
export { ForwardRef as ReactComponent };